import React from 'react';

import { getSeverityKey, getSeverityLabel } from '../helpers';

const SeverityTag = ({
  impact,
  count = null,
  size = 'default',
  className = '',
  children,
  ...rest
}) => {
  const severityKey = getSeverityKey(impact);
  const displayLabel =
    children !== undefined ? children : getSeverityLabel(severityKey);
  const classes = [
    'a11y-badge',
    size === 'mini' ? 'mini' : null,
    count !== null ? 'has-count' : null,
    `impact-${severityKey}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={classes} {...rest}>
      <span className="a11y-badge__label">{displayLabel}</span>
      {count !== null ? (
        <span className="a11y-badge__count" aria-hidden="true">
          {count}
        </span>
      ) : null}
    </span>
  );
};

export default SeverityTag;
